import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const ArrowRightIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4 11.5L9 6.5L4 1.5'
                stroke={color}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ArrowRightIcon;
